module.exports = __webpack_public_path__ + "static/hero-mobile-46a8e5be5f5013dba362354273bc26dc.jpg";